import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M28.6,61 L28.6,30.3 L33.6,30.3 L33.6,30.3 L50.1,49.5 L50.1,30.3 L55.1,30.3 L55.1,61 L50.1,61 L33.6,41.8 L33.6,61 L28.6,61 Z"
          fill="currentColor"
        />

        {/* <!-- G path (positioned right) --> */}
        {/* <path
          d="M65.6,48.3 L72.6,48.3 L72.6,61 L68.6,61 L68.6,52.3 L61.6,52.3 L61.6,57.8 C61.6,59.8 62.6,61 64.6,61 L76.6,61 C78.6,61 79.6,59.8 79.6,57.8 L79.6,33.5 C79.6,31.5 78.6,30.3 76.6,30.3 L64.6,30.3 C62.6,30.3 61.6,31.5 61.6,33.5 L61.6,44.3 L65.6,44.3 L65.6,34.3 L75.6,34.3 L75.6,48.3 L65.6,48.3 Z"
          fill="currentColor"
        /> */}
      </g>
    </g>
  </svg>
);

export default IconLogo;
